module.exports = __webpack_public_path__ + "static/media/CBNImg11.d106935c.webp";